import AbstractInstaller from "../app/core/AbstractInstaller";
import AppSignalService from "./AppSignalService";
import InitAppSignalTask from "./InitAppSignalTask";

export default class AppSignalInstaller extends AbstractInstaller {
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        injector.mapClass("appSignalService", AppSignalService, true);

        this._addStartupTask(InitAppSignalTask, "initAppSignal", 1);
    }
}